import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { memo, useState } from "react";
import pagestyles from "./PageContentStyle.module.css";
import styles from "./Publications.module.css";
import type { Publication } from "./publications.types";
import { publicationPdfUrl, publicationThumbnailUrl } from "./publicationFileUrl";
import { usePublications } from "./usePublications";

export const PublicationsContent = memo(() => {
  const { publications } = usePublications();
  const [selectedPub, setSelectedPub] = useState<Publication | null>(null);
  const publicationInFocus = selectedPub ?? publications[0];

  if (publicationInFocus === undefined) {
    return null;
  }

  return (
    <div
      className={pagestyles.contentContainer}
      style={{
        width: "90%",
        borderColor: "rgb(33, 134, 175)",
      }}
    >
      <p className={styles.innertitle}>
        Select a publication for more information
      </p>
      <div className={styles.publicationsList}>
        {publications.map((pub) => (
          <div onMouseOver={() => setSelectedPub(pub)}>
            <img
              height="200px"
              src={publicationThumbnailUrl(pub.thumbnail)}
              alt="Decarbonised Electricity Report"
              className={styles.thumbnail}
            />
          </div>
        ))}
      </div>
      <div className={styles.publicationInFocus}>
        <img
          onClick={() => window.open(publicationPdfUrl(publicationInFocus.url))}
          height="300px"
          src={publicationThumbnailUrl(publicationInFocus.thumbnail)}
          alt="Decarbonised Electricity Report"
          className={styles.thumbnail}
        />
        <div>
          <h2
            onClick={() => window.open(publicationPdfUrl(publicationInFocus.url))}
          >
            {publicationInFocus.title}
          </h2>

          {publicationInFocus.description.split("\n").map((str) => (
            <p>{str}</p>
          ))}

          <h3
            className={styles.readMore}
            onClick={() => window.open(publicationPdfUrl(publicationInFocus.url))}
          >
            Read More{" "}
            <FontAwesomeIcon className={styles.arrow} icon={faArrowRight} />
          </h3>
        </div>
      </div>
    </div>
  );
});

export default PublicationsContent;
